import React from 'react';
import {Toast} from 'primereact/toast';

const { forwardRef, useRef, useImperativeHandle } = React;
export const Notification = forwardRef((props, ref) => {
    // The component instance will be extended
    // with whatever you return from the callback passed
    // as the second argument
    const toast = useRef();

    useImperativeHandle(ref, () => ({
        showMessage(error,message) {
            //success
            // info
            // warn
            // error
            if (error === "" || error === undefined) {
                return;
            }
            if (message === "" || message === undefined) {
                return;
            }
            var severity = error ? 'error' : 'success';
                toast.current.show([
                    {
                        severity: severity,
                        summary: severity,
                        detail: message + ' message',
                        closable: false,
                        life: 3000
                    }
                ]);
        }
    }));

    return <div><Toast ref={toast} position="top-right"></Toast></div>;
});
